import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IStore } from '../store';
import { getClientProSubscriptionInfo } from '../clientProSubscriptionActions';

export const useClientProSubscriptionInfo = () => {
  const dispatch = useDispatch();
  const clientProSubscriptionInfo = useSelector((store: IStore) => store.client.clientProSubscriptionInfo);

  useEffect(() => {
    dispatch<any>(getClientProSubscriptionInfo());
  }, []);

  return { clientProSubscriptionInfo };
};
